"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finallyRecipe = void 0;
function finallyRecipe(iterableType) {
    return iterableType === 'sync'
        ? function* (callback) {
            let success = false;
            try {
                yield* this;
                success = true;
            }
            finally {
                callback(success);
            }
        }
        : async function* (callback) {
            let success = false;
            try {
                yield* this;
                success = true;
            }
            finally {
                await callback(success);
            }
        };
}
exports.finallyRecipe = finallyRecipe;
